import { AppStateWithData } from "../../../../AppStateWithData";
import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";

export interface SaveMessageAdditionalData {
    chatUId: string
}

export const saveMessageActionTypes = createRequestActionTypes('SAVE_MESSAGE_TO_SAVED')


export const saveMessage = (config: ApiConfig) => (userUId: string, chatUId: string, id: string) =>
    (dispatch: Dispatch, getState: () => AppStateWithData) => {
        
        const thunkParams: RequestThunkParameters<any, never, SaveMessageAdditionalData> = {
            method: 'PUT',
            requestActionTypes: saveMessageActionTypes,
            url: `${config.API_URL}/savedMessages/saveChatMessage?chatUId=${encodeURIComponent(chatUId)}&messageId=${encodeURIComponent(id)}`,
            actionAdditionalData: {
                chatUId: userUId
            }
        }
        return dispatch<any>(createRequestThunk(thunkParams))
    }